<script setup>
import {computed, ref} from "vue";
import {mdiClose} from "@mdi/js";

const props = defineProps({
  title: {
    type: String,
    required: false,
    default: null,
  },
  maxWidth: {
    type: Number,
    required: false,
    default: null
  },
  fullscreen: {
    type: Boolean,
    required: false,
    default: false,
  },
})
const emit = defineEmits(['close'])

const showValue = ref(true)
const show = computed({
  get() {
    return showValue.value;

  },
  set(value) {
    showValue.show = false
    emit('close', showValue.value)
  }
})
</script>

<template>
  <v-dialog v-model="show" :max-width="maxWidth" :fullscreen="fullscreen" persistent>

    <v-card>
      <slot name="header">
        <v-card-item>
          <template v-slot:title>
            <span class="text-h4">{{ title }}</span>
          </template>
          <template v-slot:append>
            <v-btn variant="elevated" rounded="xl" size="large" :icon="mdiClose"
                   @click="$emit('close')"></v-btn>
          </template>
        </v-card-item>
      </slot>

      <v-card-text>
        <slot></slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>